import Observer from 'fontfaceobserver';
function createFontClass(family) {
    return `${family.replace(/ +/g, '-').toLowerCase()}-ready`;
}
export function injectFont(primaryFont, secondaryFonts) {
    // Add `xxxx-ready` styles to set the primary (body) font
    if (primaryFont) {
        // observe body font
        const primaryFontObserver = new Observer(primaryFont);
        primaryFontObserver.load().then(() => {
            const fontClass = createFontClass(primaryFont);
            document && document.documentElement.classList.add(fontClass);
        }, () => {
            console.log(`Font ${primaryFont} not available`);
        });
    }
    // observe any secondary fonts
    if (secondaryFonts && secondaryFonts.length > 0) {
        const fonts = secondaryFonts.map(font => new Observer(font));
        Promise.all(fonts.map(f => f.load())).then(function (e) {
            e.map((fam) => {
                const fontClass = createFontClass(fam.family);
                document && document.documentElement.classList.add(fontClass);
            });
        }, () => {
            console.log('Secondary fonts not available');
        });
    }
}
//# sourceMappingURL=injectFont.js.map